import React from 'react';

import apiService from '../Services/APIService';
import { s360ConfigService } from "../Services/S360Config";

import "./InitialFormStyleSheet.css";

function InitialOfflinePage(props) {
  const renderOfflineIcon = () => (
    <svg
      width="72"
      height="49"
      viewBox="0 0 72 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 18.5V40.5C6 41.625 6.875 42.5 8 42.5H30V18.5C30 11.875 24.625 6.5 18 6.5C11.375 6.5 6 11.875 6 18.5ZM30 48.5H8C3.5 48.5 0 45 0 40.5V18.5C0 8.625 8 0.5 18 0.5H54C63.875 0.5 72 8.625 72 18.5V40.5C72 45 68.375 48.5 64 48.5H36H30ZM36 18.5V42.5H64C65 42.5 66 41.625 66 40.5V18.5C66 11.875 60.625 6.5 54 6.5H31.375C34.25 9.75 36 14 36 18.5ZM13 16.5H23C24.625 16.5 26 17.875 26 19.5C26 21.25 24.625 22.5 23 22.5H13C11.25 22.5 10 21.25 10 19.5C10 17.875 11.25 16.5 13 16.5ZM45 16.5H55H57C58.625 16.5 60 17.875 60 19.5V25.5C60 27.25 58.625 28.5 57 28.5H55C53.25 28.5 52 27.25 52 25.5V22.5H45C43.25 22.5 42 21.25 42 19.5C42 17.875 43.25 16.5 45 16.5Z"
        fill={s360ConfigService?.config.configDetails?.primaryColor}
      />
    </svg>
  );

  const renderCloseIcon = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }}
    >
      <path
        d="M16.7812 8.28125L13.0312 12.0312L16.75 15.75C17.0625 16.0312 17.0625 16.5 16.75 16.7812C16.4688 17.0938 16 17.0938 15.7188 16.7812L11.9688 13.0625L8.25 16.7812C7.96875 17.0938 7.5 17.0938 7.21875 16.7812C6.90625 16.5 6.90625 16.0312 7.21875 15.7188L10.9375 12L7.21875 8.28125C6.90625 8 6.90625 7.53125 7.21875 7.21875C7.5 6.9375 7.96875 6.9375 8.28125 7.21875L12 10.9688L15.7188 7.25C16 6.9375 16.4688 6.9375 16.7812 7.25C17.0625 7.53125 17.0625 8 16.7812 8.28125Z"
        fill={s360ConfigService?.config.configDetails?.primaryFontColor}
      />
    </svg>
  );

  const onFormSubmit = (event) => {
    event.preventDefault();
    let validated = false;
    for (let element of event.target.elements) {
      console.log(element)
      if (["email", "message"].includes(element.name) && !element.value) {
        props.actions.showPopUpMessage(`${element.name} is required`);
        validated = false;
        break;
      } else if (element.name === 'email') {
        if (!element.value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
          props.actions.showPopUpMessage(`Enter a valid ${element.name}`);
          validated = false;
          break;
        }
      } else {
        validated = true;
      }
    }
    if (validated) {
      apiService.sendOfflineForm(event.target.elements)
        .then(() => props.actions.showPopUpMessage('Request sumitted, we will get back to you'))
        .catch(() => props.actions.showPopUpMessage('Error occured, please try again'))
    }
  }

  if (s360ConfigService?.config?.configDetails?.offlineForm) {
    return (
      <div className="s360-offline-form-container">
        <div className="s360-offline-form-header">
          <div className="s360-offline-form-text-container">
            <div className="s360-offline-form-text-header">
              {s360ConfigService?.config?.configDetails?.offlineText ?? 'We are curently offline'}
            </div>
            <div className="s360-offline-form-text-subheader">
              {s360ConfigService?.config?.configDetails?.offlineIntroText ?? 'Unfortunately our agents are unavailable, we shall get back to you soon'}
            </div>
          </div>
          <div className="close-icon-offline-form" onClick={props.actions.onHideChatWindow}>{renderCloseIcon()}</div>
        </div>
        <form className="s360-offline-form-body" onSubmit={onFormSubmit}>
          <div className="s360-offline-form-input">
            <label htmlFor="s360-offline-email">Email</label>
            <input id="s360-offline-email" name="email" placeholder="Enter email" />
          </div>
          <div className="s360-offline-form-input">
            <label htmlFor="s360-offline-message">Message</label>
            <textarea id="s360-offline-message" name="message" placeholder="Enter your message" rows={5} />
          </div>
          <div className="s360-offline-form-submit">
            <button type="submit">Submit</button>
          </div>
        </form>
      </div>
    )
  }

  return (
    <div className="s360-offline-page-container">
      <div className="close-icon-offline">{renderCloseIcon()}</div>
      <div className="close-icon-main-container">
        <div className="empty-icon-offline" onClick={props.actions.onHideChatWindow}>{renderOfflineIcon()}</div>
        <div className="text-offline">
          <span>
            {s360ConfigService?.config?.configDetails?.offlineIntroText ?? 'Unfortunately our agents are unavailable, we shall get back to you soon'}
          </span>
        </div>
      </div>
    </div>
  );
}
export default InitialOfflinePage;
